import { useState } from "react";
import { Project, ValidationErrors } from "../../types/admin";
import EmailInput from "../InputComponents/EmailInput";
import StringInput from "../InputComponents/StringInput";
import SwitchInput from "../InputComponents/SwitchInput";
import ErrorMessage from "../Utils/ErrorMessage";
import SuccessMessage from "../Utils/SuccessMessage";
import TextNoConfidential from "../InputComponents/TextNoConfidentialComponent";
import DropdownStringMandatoryComponent from "../InputComponents/DropdownStringMandatoryComponent";

interface ProjectComponentProps{
    onChange : (field: keyof Project) => (e: React.ChangeEvent<HTMLInputElement>) => void;
    handleSubmit : () => Promise<void>;
    project : Project;
    errors : ValidationErrors;
    successMessage : string;
    isProjectCreation?: boolean;
}
function ProjectComponent({
    onChange,
    handleSubmit,
    project,
    errors,
    successMessage,
    isProjectCreation = false
}:ProjectComponentProps)
{
    const isFieldValid = (fieldName: string): boolean => {
        return Boolean(!(errors[fieldName] && errors[fieldName].length > 0));
    };
    return(<div className="project-container">
        <div className="row">
          <div className="col-6 visibility-button">
            <h2 className="container-title">
              Project {isProjectCreation? 'creation' : 'modification'}
            </h2>
          </div>
        </div>
        <div className="form-container">
          <div className="error-container">
            <SuccessMessage
              message={successMessage}
            />
          </div>
          
          <div className="row">
            <div className="col-sm-12">
              <StringInput
                label={"Project acronym"} 
                textValue={project.name} 
                onChange={onChange("name")} 
                maxLength={100}               
                isValid={isFieldValid('Name')}   
              />
            <ErrorMessage errors={errors["Name"]} />
            </div>

            <div className="col-sm-12">
              <StringInput
                label={"Project number"} 
                textValue={project.code} 
                onChange={onChange("code")} 
                isValid={isFieldValid('Code')}
                maxLength={100}             
              />
            <ErrorMessage errors={errors["Code"]} />
            </div>


            <div className="col-sm-12">
              <DropdownStringMandatoryComponent 
                listInputs={["-" , "SIGNED" ,"TERMINATED" ,"CLOSED", "SUSPENDED"]} 
                label={"CORDA status"} 
                inputName={""} 
                value={project.cordaStatus == null? "": project.cordaStatus} 
                handleOnChange={onChange("cordaStatus")} 
              />
            <ErrorMessage errors={errors["CordaStatus"]} />
            </div>

            <div className="col-sm-12">
              <TextNoConfidential 
              label={"Description"} 
              textValue={project.description? project.description : ""} 
              onChange={onChange("description")} 
              textValid={isFieldValid('Description')}
              textName={""} 
              isMandatory={false} 
              display={false}/>
            <ErrorMessage errors={errors["Description"]} />
            </div>
            {isProjectCreation? 
            <div className="col-sm-12">
              <SwitchInput 
              label={"Is project CBE ? "} 
              value={project.isCbe} 
              onChange={onChange("isCbe")} />
            <ErrorMessage errors={errors["Description"]} />
            </div>:
            <div className="col-sm-12">
            <SwitchInput 
            label={"CBE project "} 
            value={project.isCbe} 
            onChange={onChange("isCbe")} 
            readOnly={true}/>
          </div>
          }
          </div>
        
          <div className="row">
            <div className="col-12 d-flex justify-content-center">
              <input
                className="big-button d-block mx-auto mt-5"
                type="submit"
                value={isProjectCreation? "Create project" : "Edit project"}
                onClick={() => handleSubmit()}
              />
            </div>
          </div>
        </div>
      </div>)
}

export default ProjectComponent;